/*------------------------------------------------------------------
  - This script for updating product for seller to sell his item
-------------------------------------------------------------------*/

//Array to store product existing images
var existing_product_img = [];

// to check product have more variants 
var variantStatus = false;

$(document).ready(function() {
  var sellerName = $('.seller_name').val();
  var productId = $('.seller_update_product').attr("data-product");

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return "";
  }

  //Get the list of product types.

  //Checking if the seller is logged in, then get the list of product types.
  if (readCookie('brand_name') != null && $('#seller_name').length && readCookie('brand_name') == $('#seller_name').val()) {
    $.ajax({
      type: 'GET',
      url: 'https://test-designers.lovethisstuff.com/website/Product/getTheListOfProductTypes',
      data: "",
      dataType: 'json',
      success: function(data) {
        if (data.messageType === "SUCCESS") {
          var options = '<option value="" selected="" disabled="">Select your product type *</option><<option value ="Other"> OTHER</option>';
          $.each(data.product_types, function(i, optionHtml) {
            options += '<option value ="' + optionHtml.ProductTypes.type + '">' + optionHtml.ProductTypes.type + '</option>';
          });
          $("#update_product_type").append(options);
          $("#duplicate_product_type").append(options);

          //Listing the occasion
          var occasionOptions = '<option value="" selected="" disabled="">Select the occasion </option>';
          $.each(data.occasion_list, function(i, optionHtml) {
            $('.occasion_list_select')
              .append($("<option></option>")
                .attr("value", optionHtml.Occasion.occasion)
                .text(optionHtml.Occasion.occasion));

          });
          $('.occasion_list_select').dropdown({
            maxSelections: 2
          });
          $("#update_product_occasion").append(occasionOptions);
          //Relation list
          var relationOptions = '<option value="" selected="" disabled="">Relation </option>';
          $.each(data.relation_list, function(i, optionHtml) {
            $('.relation_list_select')
              .append($("<option></option>")
                .attr("value", optionHtml.RelationList.relation)
                .text(optionHtml.RelationList.relation));
          });

          $('.relation_list_select').dropdown({
            maxSelections: 2
          });
          $("#update_product_relation").append(relationOptions);

          $('.age_list_select').dropdown({
            maxSelections: 2
          });
        }
      },
      error: function(data) {},
      cache: false,
      contentType: false,
      processData: false
    });
  }

  var tags_arr = [];
  //Checking vendor details if same vendor enabling edit product and load product data
  if (readCookie('brand_name') != null && $('#seller_name').length && readCookie('brand_name').toLowerCase() == $('#seller_name').val().toLowerCase()) {
    var emailId = readCookie('seller_email');
    var sessionId = readCookie('session_token');
    
    	var postData = new Object();
    
        postData.shopifyProductId = productId;
        var token = readCookie('token');
     
        var jsonPostData = JSON.stringify(postData);
        var post = $.ajax({
            type: 'post',
      		url: 'https://api-test.lovethisstuff.com/v1/products/getProductDetails?token='+token+'',
            data: jsonPostData,
            contentType: 'application/json; charset=uts-8'
        });
        post.done(function(data) {
          console.log(data);
            if(data.messageType === "SUCCESS") {
              
              var product = data.productDetails.product;
          var variantSizeList = [];
          var variantColorList = [];
          var variantMaterialList = [];
          var variantSizeText = '';
          var variantColorText = '';
          var variantMaterialText = '';
          $.each(product.variants, function(index, variant) {
            if (variant.option1 !== null && variant.option1 !== '') {
              if ($.inArray(variant.option1, variantSizeList) == -1) {
                variantSizeList.push(variant.option1);
                variantSizeText = variantSizeText + variant.option1 + ",";
              }
            }
            if (variant.option2 !== null && variant.option2 !== '') {
              if ($.inArray(variant.option2, variantColorList) == -1) {
                variantColorList.push(variant.option2);
                variantColorText = variantColorText + variant.option2 + ",";
                console.log(variant.option2);
              }
            }
            if (variant.option3 !== null && variant.option3 !== '') {
              if ($.inArray(variant.option3, variantMaterialList) == -1) {
                variantMaterialList.push(variant.option3);
                variantMaterialText = variantMaterialText + variant.option3 + ",";
              }
            }
          });
          if (variantSizeText !== '' && variantSizeText !== 'Default Title,') {
            $('#variant_option_value_1').val(variantSizeText.slice(0, -1));
          }
          if (variantColorText !== '') {
            $('#variant_option_value_2').val(variantColorText.slice(0, -1));
          }
          $('#variant_option_value_3').val(variantMaterialText.slice(0, -1));

          //  var description = product.body_html.replace('<strong>','').replace('</strong>','');


          var gstPercentageValue = 0;

          var description = product.body_html;
          if ((~description.indexOf("<description>")) || (~description.indexOf("<size>")) || (~description.indexOf("<color>")) || (~description.indexOf("<material>"))) {

            /* Extract the product description  */
            var regexDescription = /<description>\s*([\S\s]*?)\s*<\/description>/g;
            var matchingDescription = [];
            while (m = regexDescription.exec(description)) {
              matchingDescription.push(m[1]);
            }


            /* Extract the product size  */
            var regexSize = /<size>Dimension :\s*([\S\s]*?)\s*<\/size>/g;
            var matchingSize = [];
            while (m = regexSize.exec(description)) {
              matchingSize.push(m[1]);
            }

            /* Extract the product color  */
            var regexColor = /<color>Color :\s*([\S\s]*?)\s*<\/color>/g;
            var matchingColor = [];
            while (m = regexColor.exec(description)) {
              matchingColor.push(m[1]);
            }


            /* Extract the product color  */
            var regexMaterial = /<material>Material :\s*([\S\s]*?)\s*<\/material>/g;
            var matchingMaterial = [];
            var materialValue = '';
            while (m = regexMaterial.exec(description)) {
              matchingMaterial.push(m[1]);
            }

            /* Extract the product care content  */
            var regexCareContent = /Care :\s*([\S\s]*?)\s*<\/care>/g;
            var matchingCareContent = [];
            while (m = regexCareContent.exec(description)) {
              matchingCareContent.push(m[1]);
            }

            $('#up_product_description').val(matchingDescription);
            $('#updateProductSize').val(matchingSize);
            $('#updateProductColor').val(matchingColor);
            $('#updateProductMaterial').val(matchingMaterial);
            $('#updateProductCare').val(matchingCareContent);

            $('#dp_product_description').val(matchingDescription);
            $('#duplicateProductSize').val(matchingSize);
            $('#duplicateProductColor').val(matchingColor);
            $('#duplicateProductMaterial').val(matchingMaterial);
            $('#duplicateProductCare').val(matchingCareContent);


          } else {

            var descriptionAfterRemovingTags = description.replace(/(<([^>]+)>)/ig, "");

            $('#up_product_description').val(descriptionAfterRemovingTags);
            $('#dp_product_description').val(descriptionAfterRemovingTags);
          }


          var tagsArray = product.tags.split(',');
          var productTagString = '';
          var deliveryValue = '';

          var labelValue = '';
          var weightValue = '' + product.variants['0'].weight;
          var skuValue = '' + product.variants['0'].sku;

          $('.product_title').val(product.title);
          // $('.product_description').val(description);
          $('.seller_email').val(emailId);
          $('.seller_session_id').val(sessionId);

          var giftsForList = [];
          var ageGroupBetween = [];
          var occasionList = [];


          for (var i = 0; i < tagsArray.length; i++) {
            var tag = tagsArray[i].trim();
            if (tag != "" && tag.length != 0 && tag != 'published' && !tag.includes(':') && tag != 'SEARCHANISE_IGNORE' && !tag.includes('age_group_between_') && !tag.includes('gifts for') && !tag.includes('occasion_') && !tag.includes('product_color_') && !tag.includes('product_material_') && !tag.includes('about_product_') && !tag.includes('HSN_code_') && !tag.includes('GST_percentage_') && !tag.includes('taxable_final_price_') && !tag.includes('taxable_original_price_')) {
              tags_arr.push(tag);
              productTagString = productTagString + tag + ",";
            } else if (tag.includes('Delivery:')) {
              var DeliveryDataAfterRemovingSpace = tag.replace(": ", ":");
              var deliveryArray = DeliveryDataAfterRemovingSpace.split(':');
              deliveryValue = deliveryArray['1'].replace(' days', '');
            }

            //Differenciate the occasion, relation and appropriate age

            if (tag.includes('occasion_')) {
              var justTag = tag.replace(/^occasion_/, '');
              occasionList.push(justTag);
            }

            if (tag.includes('gifts for')) {

              var removeStaticPrefixForGifts = tag.replace(/^gifts for /, '');
              //push it to the array
              giftsForList.push(removeStaticPrefixForGifts);

            }

            if (tag.includes('age_group_between_')) {
              var removeStaticPrefixForAgrGroup = tag.replace(/^age_group_between_/, '');
              //push it to the array
              ageGroupBetween.push(removeStaticPrefixForAgrGroup);
            }

            if (tag.includes('HSN_code_')) {
              var word = "HSN_code_";
              var hsnCode = tag.substr(tag.indexOf(word) + word.length);
              $('#update_hsn_code').val(hsnCode);
              $('#duplicate_hsn_code').val(hsnCode);
            }
            if (tag.includes('GST_percentage_')) {
              var gstPercentage = "GST_percentage_";
              var gstPercentageValue = tag.substr(tag.indexOf(gstPercentage) + gstPercentage.length);
              if(gstPercentageValue == 10){
              	gstPercentageValue = '';
              }
              console.log(gstPercentageValue);
              $('#update_gst_percentage').val(gstPercentageValue);
              $('#duplicate_gst_percentage').val(gstPercentageValue);
            }

            if (tag.includes('taxable_final_price_')) {
              var taxableFinalPrice = "taxable_final_price_";
              var taxableFinalPriceValue = tag.substr(tag.indexOf(taxableFinalPrice) + taxableFinalPrice.length);
              $('#update_taxable_final_price').val(taxableFinalPriceValue);
              $('#duplicate_taxable_final_price').val(taxableFinalPriceValue);
            }

            if (tag.includes('taxable_original_price_')) {
              var taxableOriginalPrice = "taxable_original_price_";
              var taxableOriginalPriceValue = tag.substr(tag.indexOf(taxableOriginalPrice) + taxableOriginalPrice.length);
              $('#update_taxable_original_price').val(taxableOriginalPriceValue);
              $('#duplicate_taxable_original_price').val(taxableOriginalPriceValue);
            }

            if (tag.includes('about_product_')) {
              var removeStaticPrefixForAboutProduct = tag.replace(/^about_product_/, '');
              $('select#update_about_product>option[value="' + removeStaticPrefixForAboutProduct + '"]').attr('selected', true);
              $('select#duplicate_about_product>option[value="' + removeStaticPrefixForAboutProduct + '"]').attr('selected', true);

            }
            //Getting weight count in case weight in tag
            if (tag.includes('Weight:') && product.variants['0'].weight == '0') {
              var afterRemovingSpaces = tag.replace(": ", ":");
              var weightArray = afterRemovingSpaces.split(':');
              weightValue = '' + weightArray['1'];
            }
          }


          //Pre-filling the values of Update product form
          $("#update_product_occasion").dropdown('set selected', occasionList);
          $("#update_product_relation").dropdown('set selected', giftsForList);
          $("#update_appropriate_for_age").dropdown('set selected', ageGroupBetween);
          $("#duplicate_product_occasion").dropdown('set selected', occasionList);
          $("#duplicate_product_relation").dropdown('set selected', giftsForList);
          $("#duplicate_appropriate_for_age").dropdown('set selected', ageGroupBetween);

          $('select#update_product_type>option[value="' + product.product_type + '"]').attr('selected', true);

          $('select#duplicate_product_type>option[value="' + product.product_type + '"]').attr('selected', true);


          $('.delivery_timeline').val(deliveryValue);
          $('#update_product_label').val(labelValue);
          $('#duplicate_product_label').val(labelValue);

          $('#product_tags').val(productTagString.slice(0, -1));
          $('#dp_product_tags').val(productTagString.slice(0, -1));

          if (product.variants.length === 1 && product.variants['0'].title === 'Default Title') {
            if (product.variants['0'].price != null || product.variants['0'].price != '') {
              $('.product_offer_price').val(product.variants['0'].price);

            }
            $('.product_quantity').val(product.variants['0'].inventory_quantity);
            $('.product_weight').val(weightValue);
            $('#dp_product_weight').val(weightValue);
            $('#product_weight').val(weightValue);


            $('#sku').val(skuValue);
            $('#update_sku').val(skuValue);
            $('#dp_product_sku').val(skuValue);

            if (product.variants['0'].compare_at_price != null || product.variants['0'].compare_at_price != '') {
              $('.product_price').val(product.variants['0'].compare_at_price);

              var CalculateTaxableOriginalPrice = parseInt((product.variants['0'].compare_at_price)) / (1 + (gstPercentageValue / 100));

              if (CalculateTaxableOriginalPrice == 'NaN') {
                $('#update_taxable_original_price').val(product.variants['0'].compare_at_price);
                $('#duplicate_taxable_original_price').val(product.variants['0'].compare_at_price);
              } else {
                $('#update_taxable_original_price').val(CalculateTaxableOriginalPrice.toFixed(2));
                $('#duplicate_taxable_original_price').val(CalculateTaxableOriginalPrice.toFixed(2));
              }

              var CalculateTaxableFinalPrice = parseInt(product.variants['0'].price) / (1 + (gstPercentageValue / 100));

              if (CalculateTaxableFinalPrice == 'NaN') {

                $('#update_taxable_final_price').val(product.variants['0'].price);
                $('#duplicate_taxable_final_price').val(product.variants['0'].price);

              } else {
                $('#update_taxable_final_price').val(CalculateTaxableFinalPrice.toFixed(2));
                $('#duplicate_taxable_final_price').val(CalculateTaxableFinalPrice.toFixed(2));
              }

            }


            $('.add_variant_btn').show();

            $('.update_variant_btn').hide();
          } else {
            var CalculateTaxableOriginalPrice = parseInt((product.variants['0'].compare_at_price)) / (1 + (gstPercentageValue / 100));

            if (CalculateTaxableOriginalPrice == 'NaN') {
              $('#update_taxable_original_price').val(product.variants['0'].compare_at_price);
              $('#duplicate_taxable_original_price').val(product.variants['0'].compare_at_price);
            } else {
              $('#update_taxable_original_price').val(CalculateTaxableOriginalPrice.toFixed(2));
              $('#duplicate_taxable_original_price').val(CalculateTaxableOriginalPrice.toFixed(2));
            }

            var CalculateTaxableFinalPrice = parseInt(product.variants['0'].price) / (1 + (gstPercentageValue / 100));

            if (CalculateTaxableFinalPrice == 'NaN') {

              $('#update_taxable_final_price').val(product.variants['0'].price);
              $('#duplicate_taxable_final_price').val(product.variants['0'].price);

            } else {
              $('#update_taxable_final_price').val(CalculateTaxableFinalPrice.toFixed(2));
              $('#duplicate_taxable_final_price').val(CalculateTaxableFinalPrice.toFixed(2));
            }


            variantStatus = true;
            //disabling editable value
            if (product.variants.length === 1) {

              variantStatus = true;
              //disabling editable value

              $('.product_offer_price').val(product.variants['0'].price);
              $('.product_price').val(product.variants['0'].compare_at_price);

            }

            $('#product_offer_price').prop('readonly', true);
            $('#product_quantity').prop('readonly', true);
            $('.product_weight').val(weightValue);
            $('#product_price').prop('readonly', true);

            $('.product_offer_price').prop('title', 'Please update value in variant section');
            $('.product_quantity').prop('title', 'Please update value in variant section');
            $('.product_price').prop('title', 'Please update value in variant section');

            $('.product_price').prop('placeholder', 'update price value in variant section');
            $('.product_offer_price').prop('placeholder', 'update final price in variant section');
            $('.product_quantity').prop('placeholder', 'update quantity in variant section');


            var variants = product.variants;
            var options = product.options;
            var table = document.getElementById("update_variants_tab");
            var tableHeader = document.getElementById("variant_header");
            var tableHeader = document.getElementById("variant__header_values");
            var tableBoday = document.getElementById("variant_tabel_body");

            //Price and offer price value for dulipcate product
            var dp_price;
            var dp_offer_price;
            var dp_quantity;

            //var header = table.createTHead();
            //var headerRow = tableHeader.insertRow();
            $.each(options, function(index, option) {
              var cellName = tableHeader.insertCell();
              cellName.innerHTML = option.name;
            });
            //Creating header for options
            var cellName = tableHeader.insertCell();
            cellName.innerHTML = "Quantity";
            var cellCompPrice = tableHeader.insertCell();
            cellCompPrice.innerHTML = "Original price with GST *";
            var cellPrice = tableHeader.insertCell();
            cellPrice.innerHTML = "Final price with GST, after discount";
            var taxableOriginalPrice = tableHeader.insertCell();
            taxableOriginalPrice.innerHTML = "Taxable Original Price";
            var taxableFinalPrice = tableHeader.insertCell();
            taxableFinalPrice.innerHTML = "Taxable Final Price";
            var cellDelete = tableHeader.insertCell();
            cellDelete.innerHTML = "Delete";
            var count = 0;
            $.each(variants, function(index, variant) {
              var row = tableBoday.insertRow();
              if (variant.option1 && variant.option1 != null && variant.option1 != '') {
                var cell1 = row.insertCell();
                cell1.innerHTML = variant.option1;
              }
              if (variant.option2 && variant.option2 != null && variant.option2 != '') {
                var cell1 = row.insertCell();
                cell1.innerHTML = variant.option2;
              }
              if (variant.option3 && variant.option3 != null && variant.option3 != '') {
                var cell1 = row.insertCell();
                cell1.innerHTML = variant.option3;
              }
              var cellQty = row.insertCell();
              var cellCompPrice = row.insertCell();
              var cellPrice = row.insertCell();
              var taxableOriginalPrice = row.insertCell();
              var taxableFinalPrice = row.insertCell();
              var cellDelete = row.insertCell();


              var priceAmount = 0.00;
              var compPriceAmount = 0.00;
              var displayTaxableOriginalPriceValue = '';
              var displayTaxableFinalPriceValue = '';
              if (variant.price != null && variant.price != '') {

                priceAmount = variant.price;


                var taxableFinalPriceValue = (parseInt(priceAmount) / (1 + (gstPercentageValue / 100))).toFixed(2);
                if (taxableFinalPriceValue == 'NaN') {
                  displayTaxableFinalPriceValue = 0;
                } else {

                  displayTaxableFinalPriceValue = taxableFinalPriceValue;
                }

              }
              if (variant.compare_at_price != null && variant.compare_at_price != '') {

                compPriceAmount = variant.compare_at_price;

                var taxableOriginalPriceValue = (parseInt(compPriceAmount) / (1 + (gstPercentageValue / 100))).toFixed(2);
                if (taxableOriginalPriceValue == 'NaN') {
                  displayTaxableOriginalPriceValue = 0;
                } else {
                  displayTaxableOriginalPriceValue = taxableOriginalPriceValue;
                }
              }
              if (count == 0) {
                $('#dp_product_offer_price').val(priceAmount);
                $('#dp_product_quantity').val(variant.inventory_quantity);
                $('#dp_product_price').val(compPriceAmount);
                // $('.product_weight').val(variant.weight);
              }

              var price = "<input type='hidden' class='form-control' name='variant_id[]' value='" + variant.id + "' /><input type='text' class='form-control' name='price[" + variant.id + "]' value='" + priceAmount + "' onchange='changeTaxFinal(this)' />";
              var compPrice = "<input type='text' class='form-control' name='comp_price[" + variant.id + "]' value='" + compPriceAmount + "' onchange='changeTaxOriginal(this)'/>";
              var qty = "<input type='text' id='variant_qty' class='form-control' name='quantity[" + variant.id + "]' value='" + variant.inventory_quantity + "' />";
              var taxOriginal = "<input type='text' id='tax_original[" + variant.id + "]' class='form-control' name='taxOriginal[" + variant.id + "]' value='" + displayTaxableOriginalPriceValue + "' readOnly />";
              var taxFinal = "<input type='text' id='tax_final[" + variant.id + "]' class='form-control' name='taxFinal[" + variant.id + "]' value='" + displayTaxableFinalPriceValue + "' readOnly />";
              var deleteLink = "<a class='button' id='delete-variant' data-product='" + productId + "' data-variant='" + variant.id + "' title='Delete variant'/><span class='glyphicon glyphicon-trash'></span></a>";
              cellQty.innerHTML = qty;
              cellCompPrice.innerHTML = compPrice;
              cellPrice.innerHTML = price;
              taxableOriginalPrice.innerHTML = taxOriginal;
              taxableFinalPrice.innerHTML = taxFinal;
              cellDelete.innerHTML = deleteLink;
              count++;
            });

            $('.add_variant_btn').hide();
            $('.update_variant_btn').show();
          }



          $('.product_tags').dropdown({
            allowAdditions: true
          });
          $('.product_variants').dropdown({
            allowAdditions: true
          });

          var i = 0;
          if (typeof(product.images) != "undefined" && product.images !== null) {
            var productImages = product.images;
            $.each(productImages, function(index, value) {
              $('.existing_image_div ul').append('<li style="display: inline;" class="img_list"><div class="product_img"><img src=' + value.src + ' style="height:100px;width:100px;padding:5px 5px"><a class="remove" id="img_remove" data-imageid="' + value.id + '"></a> </li>');
              $('.reorder_image_div ul').append('<li data-image-id="' + value.id + '" id="image_li_' + value.id + '" class="ui-sortable-handle"><img src=' + value.src + ' style="height:100px;width:100px;padding:5px 5px"></li>');
              existing_product_img[i++] = value.id.toString();
            });
          }
          $('.div_update_product').show();
            }
            else {
                displayAlert(serverError + data['message']);
            }
        });     
   }

});


function changeTaxOriginal(obj) {
    var objectName = obj.name;
    var ChangedValue = $('[name="' + obj.name + '"]').val();
	var gstPercentage =  $('#update_gst_percentage').val();
    var variantId = objectName.substring(objectName.lastIndexOf("[") + 1, objectName.lastIndexOf("]"));
    var ValueToBeChangedTo = parseInt(ChangedValue)  /(1+(gstPercentage/100));
    $( "input[name^='taxOriginal["+variantId+"]']" ).val(ValueToBeChangedTo.toFixed(2));
    
  }

function changeTaxFinal(obj){

 	var objectName = obj.name;
    var ChangedValue = $('[name="' + obj.name + '"]').val();
	var gstPercentage =  $('#update_gst_percentage').val();
    var variantId = objectName.substring(objectName.lastIndexOf("[") + 1, objectName.lastIndexOf("]"));
    var ValueToBeChangedTo = parseInt(ChangedValue)  /(1+(gstPercentage/100));
    $( "input[name^='taxFinal["+variantId+"]']" ).val(ValueToBeChangedTo.toFixed(2));
    
}

